// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';
import { Field, Form, Formik } from "formik";
import ErrorMessage from "../../../../Common/ErrorMessage";
import { InputType } from "../../../../Common/FormFields/InputType";
import RoundButton from "../../../../Common/RoundButton";

function OtpForm(props: any) {
  const {
    initialValues,
    validationSchema,
    onSubmitHandle,
    onChangeOtp,
    loginLoader,
    loginError,
    seconds,
    resendOTP,
    focusChange,
    checkError,
    onKeyDown,
    enterKeyPress,
    formikRef
  } = props;
  return (
    <>
      <Formik
        innerRef={formikRef}
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(value) => onSubmitHandle(value)}
      >
        {({ handleSubmit, values, touched, errors }) => (
          <Form>
            <div>
              <div>
                <Box className="optInbutBox">
                  <Field
                    component={InputType}
                    type="number"
                    name="otp_1"
                    maxLength={1}
                    onKeyUp={(e: any) => focusChange(e)}
                    value={values.otp_1}
                    onChange={onChangeOtp}
                    backgroundcolor="#ffffff"
                    showerror="false"
                    onKeyDown={onKeyDown}
                    onKeyPress={enterKeyPress}
                  />
                  <Field
                    component={InputType}
                    type="number"
                    name="otp_2"
                    maxLength={1}
                    onKeyUp={(e: any) => focusChange(e)}
                    value={values.otp_2}
                    onChange={onChangeOtp}
                    onKeyPress={enterKeyPress}
                    backgroundcolor="#ffffff"
                    showerror="false"
                  />
                  <Field
                    component={InputType}
                    type="number"
                    name="otp_3"
                    maxLength={1}
                    onKeyUp={(e: any) => focusChange(e)}
                    value={values.otp_3}
                    onChange={onChangeOtp}
                    onKeyPress={enterKeyPress}
                    backgroundcolor="#ffffff"
                    showerror="false"
                  />
                  <Field
                    component={InputType}
                    type="number"
                    name="otp_4"
                    maxLength={1}
                    onKeyUp={(e: any) => focusChange(e)}
                    value={values.otp_4}
                    onChange={onChangeOtp}
                    onKeyPress={enterKeyPress}
                    backgroundcolor="#ffffff"
                    showerror="false"
                  />
                </Box>
                {checkError(errors)}
                <p
                  className="resend-otp"
                  style={{ cursor: seconds === 0 ? "pointer" : "default" }}
                  onClick={() => resendOTP()}
                >
                  {seconds > 0 ? `resend OTP in ${seconds} sec.` : <RoundButton title="resend otp" />}
                </p>
              </div>
            </div>
            <div style={{ marginBottom: "20px" }}>
              {loginError && <ErrorMessage text={loginError} />}
              <div> {/*className="bottomBtn*/}
                <RoundButton
                  title="continue"
                  type="submit"
                  disable={loginLoader}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default OtpForm;